module.exports = __webpack_public_path__ + "img/4-3.3a512c09.png";